<template>
	<ul class="uni-slidingMenu" scroll-x>
		<li  :class="['slidingMenuList',activeIndex==item.id?'active':'']" v-for="(item, index) in list" :key="index" @click="getActive(item.id)" v-cloak>{{ item.title }}</li>
		<li style="background: #FFFFFF;"></li>
	</ul>
</template>

<script>
export default {
	name: 'uniSlidingMenu',
	props:{
		// 列表菜单
		list:{
			type: Array,
			// default:['首页1', '首页2', '首页3', '首页4', '首页4', '首页4', '首页4', '首页4']
		},
		color:{
			type:String,
			default:'#777777'
		}
		
	},
	data() {
		return {
			// list: ['首页1', '首页2', '首页3', '首页4', '首页4', '首页4', '首页4', '首页4'],
			activeIndex:"280"
		};
	},
	methods:{
		getActive(index){
			this.activeIndex=index;
			this.$emit("changes",this.activeIndex);
		}
	}
};
</script>

<style>
	.uni-slidingMenu li {
			 float: left;
			 list-style:none;
			 background: #f0f0f0;
			 margin-right: 30px;
			 font-size: 16px;
			 padding: 10px 30px;
			 border-radius: 10px;
			 cursor: pointer;
			 }
/* 滑动菜单栏的总内容区域 */
.uni-slidingMenu {
	white-space: nowrap; width: 2600px;
}
/* 循环显示的菜单栏 */
.slidingMenuList {
	height: 80rpx;
	line-height: 80rpx;
	display: inline-block;
	font-size: 24rpx;
	margin-left: 60rpx;
}
.slidingMenuList:last-child{
	margin-right: 60rpx;
}
/* 点击选中菜单栏时的样式 */
.active {
	color:#d70d19;
	font-weight: bold;
	font-size: 28rpx;
	margin-left: 80rpx;
	border-bottom: 2rpx solid pink;
	box-sizing: border-box;
}
</style>
